import { render, staticRenderFns } from "./touristComplainHandleSatisfaction.vue?vue&type=template&id=28d2cf1e&scoped=true"
import script from "./touristComplainHandleSatisfaction.vue?vue&type=script&lang=js"
export * from "./touristComplainHandleSatisfaction.vue?vue&type=script&lang=js"
import style0 from "./touristComplainHandleSatisfaction.vue?vue&type=style&index=0&id=28d2cf1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d2cf1e",
  null
  
)

export default component.exports